export const GET_SINGLE_ADVERTISEMENT_START =
  'GET_SINGLE_ADVERTISEMENT_START';
export const GET_SINGLE_ADVERTISEMENT_SUCCESS =
  'GET_SINGLE_ADVERTISEMENT_SUCCESS';
export const GET_SINGLE_ADVERTISEMENT_ERROR =
  'GET_SINGLE_ADVERTISEMENT_ERROR';
